import React, { useRef, useEffect, useState } from 'react';
import './MathBlock.css';

const MathBlock = ({ label, tex, where }) => {
  const mathRef = useRef(null);
  const [katexReady, setKatexReady] = useState(!!window.katex);

  useEffect(() => {
    if (window.katex) {
      setKatexReady(true);
      return undefined;
    }
    // Wait for KaTeX to load (defer script)
    const check = setInterval(() => {
      if (window.katex) {
        setKatexReady(true);
        clearInterval(check);
      }
    }, 100);
    return () => clearInterval(check);
  }, []);

  useEffect(() => {
    if (mathRef.current && katexReady && window.katex) {
      window.katex.render(tex, mathRef.current, {
        displayMode: true,
        throwOnError: false,
        trust: true,
      });
    }
  }, [tex, katexReady]);

  return (
    <div className="math-block">
      {label && <span className="math-block__label">{label}</span>}
      <div className="math-block__equation" ref={mathRef} />
      {where && (
        <div className="math-block__where">
          {where.map((line, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <span key={i} className="math-block__where-line">{line}</span>
          ))}
        </div>
      )}
    </div>
  );
};

export default MathBlock;
